import { api } from "@/services/api"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import useEvents from "@/modules/calendar/stores/use-events"
import { isClientError } from "@educabot/fetcher"
import { toast } from "sonner"

export default function useUpdateEvent() {
  const queryClient = useQueryClient()
  const { updateEvents, setEvents } = useEvents()

  const mutation = useMutation({
    mutationKey: ["update-event"],
    mutationFn: api.cronos.user.events.update,
    onMutate: async (updatedEventData) => {
      const { body, eventId } = updatedEventData

      const previousEvents = useEvents.getState().events
      const updatedEvents = previousEvents.map((event) => {
        return event.id === eventId
          ? {
              ...event,
              startDate: body.startDate,
              endDate: body.endDate,
            }
          : event
      })

      setEvents(updatedEvents)
      return { previousEvents }
    },
    onError: (error, _, context) => {
      const isPastTimeError = isClientError(error) && error.code === "U8"

      toast.error("Algo salió mal", {
        description: isPastTimeError
          ? "No se puede editar eventos pasados o moverlos a días u horas pasadas"
          : "No se pudo realizar la acción",
      })

      if (context) {
        useEvents.getState().setEvents(context.previousEvents)
      }
    },
    onSuccess(data, variables) {
      const { isBulkUpdate } = variables.body
      const editedEvents = data.data.description
      updateEvents(editedEvents, isBulkUpdate)
    },
    onSettled() {
      queryClient.invalidateQueries({ queryKey: ["get-daily-calendar"] })
    },
  })

  return mutation
}
